import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import {
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";
import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { ValidationError, object, string } from "yup";
import styles from "../../contactUs/contactus.module.scss";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import apiPath from "../../../config/apiPaths.json";

interface ErrorMessageTypes {
  date: string;
}

const RevenueReport = ({ sendDataToParent, getReportData }: any) => {
  const [formData, setFormData] = useState({
    date: "",
  });

  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    date: "",
  });

  const validationSchema = object().shape({
    poojaWeek: string().required("Please select week is required"),
  });
  const [loading, setLoading] = useState(false);

  const handleRevenueReport = async () => {
    let reqBody = {};
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/revenue/REVENUE_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        sendDataToParent(true, { reqBody });
        const response = res.data.map((report: any) => {
          return {
            "Receipt No.": report.receiptnumber,
            "Reference No.": report.id,
            "Receipt Date": report.dateofpoojabooking,
            "Mode of Payment": report.modeofpayment,
            "Check Number/Account Holder Name": report.checknumber,
            "Date of transaction": report.transactiondate,
            "Devotee Name(Sign-in Name)": `${report.firstname} ${report.lastname} (${report.username})`,
            "Pooja Name": report.poojaname,
            "Priest Name(Sign-in Name)": report.priest,
            "Pooja Date": report.poojadate,
            "Priest Selected By(Sign-in Name)":
              report.priest_selectedby || "--",
            "Donation Amount": formatAmount(report.amount),
            "Refund Amount": formatAmount(report.refundamount),
            "Refund Date": report.refunddate,
            "Refund Reason": report.reasonforrefund,
            "Refund Check Number": report.refund_checknumber,
          };
        });
        getReportData(response);
      })

      .catch((err) => {});
  };

  const handleSave = async (): Promise<any> => {
    const errors: ErrorMessageTypes = {
      date: "",
    };
    try {
      // Validate the form data against the validation schema
      // await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      // setErrorMessage(errors);
      // Call your API or perform other actions here
      handleRevenueReport();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };
  const handleFieldChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const datePicker = (): React.ReactElement => {
    return (
      <div className={styles.pookaWeekPickerContainer}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={formData.date ? dayjs(formData.date, "MM/DD/YYYY") : ""}
                onChange={(value) => {
                  handleFieldChange("date", value);
                }}
                className={
                  errorMessage.date ? styles.errorTextField : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.date ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.date}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  return (
    <Grid
      spacing={2}
      sx={{ display: "flex", flexDirection: "column", gap: "16px" }}
    >
      <Grid
        xs={12}
        sm={3}
        item
        className={styles.abhishekamReportsMainContainer}
      >
        {datePicker()}
      </Grid>
      <CommonOutlinedButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleSave}
        disabled={loading}
        id="submit"
      >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
      </CommonOutlinedButton>
    </Grid>
  );
};
export default RevenueReport;
